<template>
  <div class="image-modal-cover">
    <div class="stopwatch-setting-container" @click.stop>
      <GrmCamstudyOptionModal
          @onCloseOption="onCloseOption"
          @onNextAct="onNextAct"
          name="stopwatch-setting"
          :list="[
            {name: $t('camstudy.stopwatch.todayStudyTime')},
            {name: $t('camstudy.stopwatch.targetStudyTime')},
            {name: $t('camstudy.stopwatch.totalStudyTime')},
            {name: $t('camstudy.stopwatch.myDDay')},
            {name: $t('camstudy.stopwatch.studyPeriod')}
          ]"
          :value="optionData"
          type="checkbox"
          :title="$t('camstudy.stopwatch.setting.title')"
      >
<!--        <div class="button-container">-->
<!--          <button @click="reqResetStopwatch"><img src="@/assets/images/camstudy/ico_reload_white.svg" class="stopwatch-control-button-image" :alt="$t('common.reset')" />{{ $t('camstudy.stopwatch.setting.resetStudyTime') }}</button>-->
<!--          <button @click="onOpenImageModal"><img src="@/assets/images/camstudy/ico_download_white.svg" class="stopwatch-control-button-image" :alt="$t('common.save')" />{{ $t('camstudy.stopwatch.setting.saveImage') }}</button>-->
<!--        </div>-->
      </GrmCamstudyOptionModal>
    </div>
  </div>
</template>

<script>
import GrmCamstudyOptionModal from "@/components/Common/camstudyOptionModal/GrmCamstudyOptionModal.vue";
import html2canvas from "html2canvas";
import {mapActions, mapGetters} from "vuex";
import dayjs from "dayjs";

export default {
  name: 'CamstudyStopWatchSettingModal',
  components: {GrmCamstudyOptionModal},
  data() {
    return {
      settingInfo: [
        {
          name: this.$t('camstudy.stopwatch.todayStudyTime'),
          key: 'todayStudyTime',
          value: false
        },
        {
          name: this.$t('camstudy.stopwatch.targetStudyTime'),
          key: 'targetStudyTime',
          value: false
        },
        {
          name: this.$t('camstudy.stopwatch.totalStudyTime'),
          key: 'totalStudyTime',
          value: false
        },
        {
          name: this.$t('camstudy.stopwatch.myDDay'),
          key: 'remainDays',
          value: false
        },
        {
          name: this.$t('camstudy.stopwatch.studyPeriod'),
          key: 'studyDays',
          value: false
        },
      ],
      isOpenImageModal: false,
      modalComponent: '',
      selectedImage: 'image1',
      tempSelectedImage: 'image1',
      customImage: '',
      days: dayjs(),
      formatTotalStudyTime: '',
      isDownloading: false,
    }
  },
  computed: {
    ...mapGetters('user', ['me']),
    ...mapGetters('camstudy', ['getUserStopwatch', 'getCamStudyUser', 'getUserStudyData', 'studyInfoSetting']),
    optionData() {
      return this.settingInfo.map(setting => setting.value)
    },
    stopwatch() {
      return this.getUserStopwatch(this.me.userId)
    },
    stopwatchState() {
      return this.stopwatch?.state || 'pause'
    },
    studyData() {
      return this.getUserStudyData(this.me.userId)
    },
  },
  mounted() {
    this.initSetting()
  },
  methods: {
    ...mapActions('camstudy', ['changeStopwatchState', 'resetStopwatch', 'saveMyInfoSetting']),
    onCloseOption(){
      this.$modal('CamstudyStopWatchSettingModal', {data: {fade: false}})
    },
    initSetting() {
      this.settingInfo.forEach((setting) => {
        setting.value = this.studyInfoSetting[setting.key]
      })
    },
    onNextAct(data){
      const setting = this.settingInfo.reduce((obj, item, index) => {
        obj[item.key] = data[index]
        return obj
      }, {})
      this.saveMyInfoSetting(setting)
      this.onCloseOption()
    },
  }
}
</script>

<style scoped lang="scss">
.room-stopwatch-btn-container{
  position: absolute;
  top: 16px;
  @media(orientation: portrait) {
    right: 16px;
  }
  @media(orientation: landscape) {
    right: 79px;
  }
}
.room-stopwatch-btn {
  width: 32px;
  height: 32px;
  background: url('~@/assets/images/camstudy/ico_widget_setting_white.svg') center no-repeat;
}
.button-container{
  display: flex;
  gap: 12px;
  padding: 12px 20px;
  justify-content: center;
  button{
    width: 100%;
    display: flex;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #1F1F1F;
    color: #FFF;
    text-align: center;
    font-size: 14px;
    line-height: 150%;
    .stopwatch-control-button-image{
      width: 17px;
      height: 17px;
      margin-right: 6px;
    }
  }
}
</style>